// Moka pot badge tiers based on number of reviews written.
export const BADGE_TIERS = [
  { min: 9, level: 'gold', label: 'Gold Moka Master', color: '#d4a029' },
  { min: 6, level: 'silver', label: 'Silver Moka', color: '#9ca3af' },
  { min: 3, level: 'bronze', label: 'Bronze Moka', color: '#b87333' },
];

export function getBadgeTier(reviewCount = 0) {
  return BADGE_TIERS.find((t) => reviewCount >= t.min) || null;
}